// src/redux/slices/userSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { baseURL } from "../Repo/Repository";

// Thunk to fetch agent JWT token
export const fetchAgentToken = createAsyncThunk(
  "user/fetchAgentToken",
  async (_, thunkAPI) => {
    const email = localStorage.getItem("email");
    if (!email) return null;
    try {
      const res = await axios.post(`${baseURL}/agent/token`, { email });
      const token = res.data.token;
      localStorage.setItem("agent_token", token);
      return token;
    } catch {
      return null;
    }
  }
);

// Thunk to fetch user data
export const getUser = createAsyncThunk("user/getUser", async (_, thunkAPI) => {
  const email = localStorage.getItem("email");
  try {
    const response = await axios.post(`${baseURL}/get-user`, { email });
    // Ensure the user data is properly formatted for one-time payments
    if (response.data?.plan === "starter") {
      response.data.subscription = {
        ...response.data.subscription,
        price: 10,
        type: "one-time"
      };
    }
    // Fetch agent JWT token after successful user load
    thunkAPI.dispatch(fetchAgentToken());
    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(
      error.response?.data || "Error fetching user"
    );
  }
});

export const userSlice = createSlice({
  name: "user",
  initialState: {
    user: null,
    loading: false,
    isLoggedIn: false,
  },
  reducers: {
    updateCredits(state, action) {
      if (state.user) {
        state.user.credits = action.payload;
      }
    },
    logout(state) {
        const email = localStorage.getItem("email");

      state.user = null;
      state.isLoggedIn = false;
      state.loading = false;
      localStorage.removeItem("email");
      localStorage.removeItem("customerId");
      localStorage.removeItem("agent_token");
       if (email) {
    sessionStorage.removeItem(`feedbackShown_${email}`);
  }
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getUser.pending, (state) => {
        state.loading = true;
      })
      .addCase(getUser.fulfilled, (state, action) => {
        state.loading = false;
        state.user = action.payload;
        state.isLoggedIn = true;
        if (action.payload?.customer_id) {
          localStorage.setItem("customerId", action.payload.customer_id);
        } else {
          localStorage.removeItem("customerId");
        }
      })
      .addCase(getUser.rejected, (state) => {
        state.loading = false;
        state.user = null;
        state.isLoggedIn = false;
      });
  },
});
export const { logout, updateCredits } = userSlice.actions;
export default userSlice.reducer;
